import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthService } from '../services/auth/auth.service';

export const AuthGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
): boolean | UrlTree => {
  const authService = inject(AuthService);
  const platformId = inject(PLATFORM_ID);
  const router = inject(Router);

  const authTokenData = authService.authTokenData();

  if (isPlatformBrowser(platformId)) {
    if (authTokenData && authTokenData.token && authTokenData.expToken) {
      const currentTime = Math.floor(Date.now() / 1000);
      const tokenExpirationDate = Math.floor(new Date(authTokenData.expToken).getTime() / 1000);

      if (authTokenData.token && tokenExpirationDate <= currentTime) {
        authService.logout('Twoja sesja wygasła. Wylogowano pomyślnie.');
        return router.createUrlTree(['/login']);
      }

      return true;
    }
    return router.createUrlTree(['/login'], { queryParams: { redirect: state.url } });
  }

  return false;
};
